module.exports = __webpack_public_path__ + "static/images/gift-1.cc3ff94.png";